import React from 'react';
import './App.css';
import './Notebook.css';
import NotebookLang from './NotebookLang.json';
import { DownloadExcelHelpers } from './DownloadExcelHelpers.js';
import { saveAs } from 'file-saver';

import { useNavigate } from "react-router-dom";

class NotebookAnalysis extends React.Component {
	
	constructor(props) {

		super(props);

		this.state = {
			intervalID: null,
			outTextArray: null,
		}
	}		

	componentDidMount() {
		this.processAllSources();
		this.intervalID = setInterval(() => {
			this.refreshPodcastData();
		}, 60*1000);
	}

	componentWillUnmount() {
		clearInterval(this.intervalID);
	}

	async componentDidUpdate() {
		var outTextArray = this.state.outTextArray;
		if (outTextArray === null) {
			this.processAllSources();
		}
	}
	
	async refreshPodcastData() {
		var notebookJsonObj = this.props.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}
		if ((notebookJsonObj.podcastStatusCode > 0) && (notebookJsonObj.podcastStatusCode < 4)) {
			this.props.refreshData();
		}
	}

	async serverSetNotebookPodcastStatusCode(notebookID, podcastStatusCode) {

		var baseURLAPI = this.props.baseURLAPI;
		var url = baseURLAPI + "/setnotebookpodcaststatuscode?notebookid=" + notebookID;
		url = url + "&podcaststatuscode=" + podcastStatusCode;
		
		try {
			var res = await fetch(url);
			await res.text();
		} catch (err) {
		}
	}

	onClickSource(index) {
		this.props.setSourceIndex(index);
		var navigate = this.props.navigate;
  		navigate("/source/result");
	}
	
	async onClickDownloadExcel() {

		var toastString = this.props.getLang(NotebookLang, "downloadExcelToast");
		this.props.showToast(toastString);

		var downloadExcelHelpersObj = new DownloadExcelHelpers();
		downloadExcelHelpersObj.baseURLAPI = this.props.baseURLAPI;
		var excelBuffer = await downloadExcelHelpersObj.createExcel(this.props.notebookJsonObj, this.props.sourceArray);

		var filename = "NotebookAnalysis.xlsx";
		var blob = new Blob([excelBuffer], { type: 'application/octet-stream' });	
		saveAs(blob, filename);
 	}
	
	onClickEditPrompt() {
		var navigate = this.props.navigate;
  		navigate("/notebook/prompt");
 	}
	
	onClickDoc(docType) {
		this.props.setDocType(docType);
		var navigate = this.props.navigate;
  		navigate("/notebook/doc");
	}
	
	async onClickGeneratePodcast() {
		var toastString = this.props.getLang(NotebookLang, "generatePodcastStarted");
		this.props.showToast(toastString);
		var notebookID = this.props.notebookID;
		var podcastStatusCode = 1;
		await this.serverSetNotebookPodcastStatusCode(notebookID, podcastStatusCode);
		this.props.refreshData();
 	}
	
	async processOneSource(index, itemObj) {
		
		var notebookJsonObj = this.props.notebookJsonObj;
		var notebookStorageID = notebookJsonObj.storageID;
		var sourceURL = "https://notebookapi.dbtouch.com/source/" + notebookStorageID;
		var filenameExt = itemObj.filename;

		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		var filenameOut = filename + ".out";
		var outURL = sourceURL + "/" + filenameOut;
		var outText = await this.props.serverDownloadTextFile(outURL);

		return outText;
	}
	
	async processAllSources() {

		// for now
		return;

		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		var i;
		var itemObj;
		var outText;
		var outTextArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			outText = await this.processOneSource(i, itemObj);
			outTextArray.push(outText);
		}

		this.setState({
			outTextArray: outTextArray,
		});
	}
		
	renderOneSource(index, itemObj) {
		
		var key = "source-" + index;
		var filenameExt = itemObj.filename;
		var filename = filenameExt.substring(0, filenameExt.lastIndexOf('.'));
		//var outTextArray = this.state.outTextArray;
		//var outText = "";
		
		/*if (outTextArray !== null) {
			if (index < outTextArray.length) {
				outText = outTextArray[index];
			}
		}*/

		return (
			<div key={key}>
				<div className="NotebookAnalysisListFilenameItem" onClick={() => this.onClickSource(index)}>{filename}</div>
				<div style={{height: "5px"}}></div>
			</div>
		);
	}
	
	renderAllSources() {

		var sourceArray = this.props.sourceArray;

		var i;
		var itemObj;
		var jsxCode;
		var jsxArray = [];
		
		for(i=0; i<sourceArray.length; i++) {
			itemObj = sourceArray[i];
			jsxCode = this.renderOneSource(i, itemObj);
			jsxArray.push(jsxCode);
		}

		if (sourceArray.length > 0) {
			return (
				<div>
					{jsxArray}
					<hr className="NotebookCustomLine" />
				</div>
			);
		}
		
		return jsxArray;
	}
	
	renderExcelPromptButtons() {
		
		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		var displayEditPromptButtonYN = false;
		if (this.props.ownerYN) {
			displayEditPromptButtonYN = true;
		}

		var displayDownloadExcelButtonYN = false;
		if (sourceArray.length > 0) {
			displayDownloadExcelButtonYN = true;
		}

		if (displayDownloadExcelButtonYN && displayEditPromptButtonYN) {
			return (
				<div>
					<button className="ViewSaveButton" onClick={() => this.onClickDownloadExcel()}>{this.props.getLang(NotebookLang, "downloadExcel")}</button>&nbsp;&nbsp;
					<button className="ViewSaveButton" onClick={() => this.onClickEditPrompt()}>{this.props.getLang(NotebookLang, "editPrompt")}</button>
				</div>
			);
		}

		if (displayDownloadExcelButtonYN) {
			return (
				<button className="ViewSaveButton" onClick={() => this.onClickDownloadExcel()}>{this.props.getLang(NotebookLang, "downloadExcel")}</button>
			);
		}

		if (displayEditPromptButtonYN) {
			return (
				<button className="ViewSaveButton" onClick={() => this.onClickEditPrompt()}>{this.props.getLang(NotebookLang, "editPrompt")}</button>
			);
		}
	}

	renderDocButtons() {
		
		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		if (sourceArray.length === 0) {
			return;
		}

		return (
			<div>
				<button className="NotebookGreyButton" onClick={() => this.onClickDoc("faq")}>{this.props.getLang(NotebookLang, "faq")}</button>&nbsp;&nbsp;
				<button className="NotebookGreyButton" onClick={() => this.onClickDoc("studyGuide")}>{this.props.getLang(NotebookLang, "studyGuide")}</button>
				<div style={{height: "20px"}}></div>
				<button className="NotebookGreyButton" onClick={() => this.onClickDoc("individualSummary")}>{this.props.getLang(NotebookLang, "individualSummary")}</button>&nbsp;&nbsp;
				<button className="NotebookGreyButton" onClick={() => this.onClickDoc("togetherSummary")}>{this.props.getLang(NotebookLang, "togetherSummary")}</button>
				<div style={{height: "20px"}}></div>
				<hr className="NotebookCustomLine" />
			</div>
		);
	}
		
	renderPodcastButtonLink() {
		
		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		if (sourceArray.length === 0) {
			return;
		}

		var notebookJsonObj = this.props.notebookJsonObj;
		var podcastStatusCode = notebookJsonObj.podcastStatusCode;
		
		if (podcastStatusCode === null) {
			podcastStatusCode = 0;
		}
		
		if (podcastStatusCode === 0) {
			return (
				<div>
					<button className="ViewSaveButton" onClick={() => this.onClickGeneratePodcast()}>{this.props.getLang(NotebookLang, "generatePodcast")}</button>
				</div>
			);
		}

		if (podcastStatusCode === 1) {
			return (
				<div>{this.props.getLang(NotebookLang, "generatePodcastWaiting")}</div>
			);
		}

		if (podcastStatusCode === 2) {
			return (
				<div>{this.props.getLang(NotebookLang, "generatePodcastScript")}</div>
			);
		}

		if (podcastStatusCode === 3) {
			return (
				<div>{this.props.getLang(NotebookLang, "generatePodcastAudio")}</div>
			);
		}

		if (podcastStatusCode === 4) {

			var notebookStorageID = notebookJsonObj.storageID;
			var unixTimeMs = Date.now();
			var podcastMP3Url = "https://storage.googleapis.com/" + notebookStorageID + "/podcast.mp3?r=" + unixTimeMs;

			return (
				<div>
					<button className="ViewSaveButton" onClick={() => this.onClickGeneratePodcast()}>{this.props.getLang(NotebookLang, "generatePodcast")}</button>
					<div style={{height: "12px"}}></div>
					<div>
						<a href={podcastMP3Url} target="_blank" rel="noopener noreferrer">
							{this.props.getLang(NotebookLang, "listenToPodcast")}
						</a>						
					</div>
				</div>
			);
		}
	}

	render() {
		
		var notebookJsonObj = this.props.notebookJsonObj;
		if (notebookJsonObj === null) {
			return;
		}

		var sourceArray = this.props.sourceArray;
		if (sourceArray === null) {
			return;
		}

		return (
			<div className="NotebookAnalysisTopContainer">
				<div style={{height: "12px"}}></div>
				<div className="NotebookSourceTitle">{this.props.getLang(NotebookLang, "analysis")}</div>
				<hr className="NotebookCustomLine" />
				{this.renderAllSources()}
				<div style={{height: "20px"}}></div>
				{this.renderExcelPromptButtons()}
				<div style={{height: "20px"}}></div>
				<hr className="NotebookCustomLine" />
				<div style={{height: "20px"}}></div>
				{this.renderDocButtons()}
				<div style={{height: "20px"}}></div>
				{this.renderPodcastButtonLink()}
				<div style={{height: "12px"}}></div>
			</div>
		);
	}
}

export default function NotebookAnalysisFunction(props) {
	const navigate = useNavigate();
	return <NotebookAnalysis {...props} navigate={navigate} />;
}

